import React from 'react';
import '../../App.scss';
import AuthorizedPage from '../../component/AuthorizedPage';
import { Role } from '../../domain/Role';
import ShipmentApi from '../../api/ShipmentApi';
import WarehouseApi from '../../api/WarehouseApi';
import ProductApi from '../../api/ProductApi';
import BuyerApi from '../../api/BuyerApi';
import { FormationPoint } from '../../component/TruckFormation';
import UniversalNotificationToast from '../../component/UniversalNotificationToast';

// ALT BİLEŞENLER
import ShipmentList from '../../component/ShipmentList';
import ShipmentFormationModal from '../../component/ShipmentFormationModal';
import LoadedItemsModal from '../../component/LoadedItemsModal';
// ❌ ConfirmationModal importunu kaldırdık

interface State {
    shipments: any[];
    showShipmentModal: boolean;
    selectedShipmentVehicleId: number | null;
    selectedShipmentId: number | null;
    formationPoints: FormationPoint[];
    showFormationAndProductModal: boolean;
    selectedBoxIndex: number | null;
    products: any[];
    filteredProducts: any[];
    selectedProduct: any | null;
    quantity: string;
    warehouses: any[];
    selectedWarehouse: any | null;
    loading: boolean;
    error: string | null;
    loadedItems: any[];
    plannedItems: any[];
    showLoadedItemsModal: boolean;
    selectedLayer: number;
    // ❌ showConfirmationModal state'ini kaldırdık
    shipmentToCompleteId: number | null;
    notifyShow: boolean;
    notifyMessage: string | null;
    notifyType: string | null;
    loadingMode: 'FREE' | 'PLAN';
    buyers: any[];
    selectedBuyer: any | null;
}

class WareHouseShipmentManagement extends React.Component<any, State> {
    constructor(props: any) {
        super(props);
        this.state = {
             shipments: [],
             showShipmentModal: false,
             selectedShipmentVehicleId: null,
             selectedShipmentId: null,
             formationPoints: [],
             showFormationAndProductModal: false,
             selectedBoxIndex: null,
             products: [],
             filteredProducts: [],
             selectedProduct: null,
             quantity: '',
             warehouses: [],
             selectedWarehouse: null,
             loading: false,
             error: null,
             loadedItems: [],
             plannedItems: [],
             showLoadedItemsModal: false,
             selectedLayer: 1,
             // ❌ showConfirmationModal: false (Kaldırıldı)
             shipmentToCompleteId: null,
             notifyShow: false,
             notifyMessage: "",
             notifyType: "info",
             loadingMode: 'PLAN',
             buyers: [],
             selectedBuyer: null,
        };
    }

    componentDidMount() {
        this.loadShipments();
        this.loadWarehouses();
        this.loadBuyers();
    }

    showNotify = (msg: string, type: string = "info") => {
        this.setState({
            notifyShow: true,
            notifyMessage: msg,
            notifyType: type
        });
    };

    // ==========================================
    // 1. VERİ YÜKLEME METOTLARI
    // ==========================================

    loadShipments = async () => {
        this.setState({ loading: true, error: null });
        try {
            const response = await ShipmentApi.listByStatus("LOADING");
            if (response.success) {
                this.setState({ shipments: response.data });
            } else {
                this.setState({ error: "Sevkiyatlar alınamadı: " + (response.error || "Bilinmeyen hata") });
            }
        } catch (err) {
            console.error(err);
            this.setState({ error: "Sevkiyatlar alınırken hata oluştu" });
        } finally {
            this.setState({ loading: false });
        }
    }

    loadWarehouses = async () => {
        try {
            const response = await WarehouseApi.listAllWarehousesByStockType("FOODS");
            if (response.success) {
                this.setState({ warehouses: response.data });
            } else {
                console.error("Depolar alınamadı:", response.error);
                this.setState({ warehouses: [] });
            }
        } catch (err) {
            console.error("Depolar yüklenirken hata oluştu:", err);
            this.setState({ warehouses: [] });
        }
    };

    loadBuyers = async () => {
        try {
            const response = await BuyerApi.listAllCards();
            if (response.success) {
                this.setState({ buyers: response.data });
            } else {
                console.error("Müşteri kartları alınamadı", response.error);
            }
        } catch (err) {
            console.error("Müşteriler yüklenemedi", err);
        }
    }

    fetchLoadedItems = async (shipmentId: number) => {
        try {
            const response = await ShipmentApi.listLoadedItems(shipmentId);
            if (response.success) {
                this.setState({
                    loadedItems: response.data.loadedOrderItemDTOS,
                    selectedShipmentVehicleId: shipmentId,
                    selectedShipmentId: shipmentId,
                });
            } else {
                alert("Yüklenen ürünler alınamadı: " + (response.error || "Bilinmeyen hata"));
            }
        } catch (err) {
            console.error(err);
            alert("Yüklenen ürünler getirilirken hata oluştu.");
        }
    };

    fetchPlannedItems = async (shipmentId: number) => {
        try {
            const response = await ShipmentApi.listContentOfShipment(shipmentId);
            if (response.success) {
                const items = response.data.items || response.data;
                this.setState({ plannedItems: items || [] });
            } else {
                console.error("Planlanan ürünler alınamadı: " + response.error);
                this.setState({ plannedItems: [] });
            }
        } catch (err) {
            console.error(err);
            this.setState({ plannedItems: [] });
        }
    };

    // ==========================================
    // 2. AKSİYONLAR
    // ==========================================

    handleViewLoadedItems = async (shipmentId: number) => {
        this.setState({ loading: true });
        await Promise.all([
            this.fetchLoadedItems(shipmentId),
            this.fetchPlannedItems(shipmentId)
        ]);
        this.setState({ showLoadedItemsModal: true, loading: false });
    };

    handleEditClick = async (shipment: any) => {
        this.setState({
            selectedShipmentVehicleId: shipment.vehicleId,
            selectedShipmentId: shipment.id,
            loading: true,
        });

        try {
            await Promise.all([
                this.fetchLoadedItems(shipment.id),
                this.fetchPlannedItems(shipment.id),
            ]);

            const formationResponse = await ShipmentApi.listVehicleFormationPoints(shipment.vehicleId);
            if (!formationResponse.success) throw new Error("Formasyon noktaları alınamadı");

            const productResponse = await ProductApi.listAllBoxedProductCards();
            if (!productResponse.success) throw new Error("Ürünler alınamadı");

            this.setState({
                formationPoints: formationResponse.data,
                products: productResponse.data,
                filteredProducts: productResponse.data,
                showFormationAndProductModal: true,
                selectedBoxIndex: null,
                selectedProduct: null,
                quantity: '',
                loadingMode: 'PLAN',
                selectedBuyer: null,
            });
        } catch (err: any) {
            console.error(err);
            alert("Hata: " + (err.message || "Bilinmeyen hata"));
        } finally {
            this.setState({ loading: false });
        }
    }

    handleUnconfirmClick = async (shipmentId: number) => {
        const confirmMsg = "Bu sevkiyatı 'Planlama Aşamasına' geri döndürmek üzeresiniz.\n\nDevam etmek istiyor musunuz?";
        if (!window.confirm(confirmMsg)) return;

        this.setState({ loading: true });
        try {
            const response = await ShipmentApi.unconfirmShipmentPlan(shipmentId);
            if (response?.success) {
                this.showNotify("Sevkiyat geri döndürüldü.", "success");
                await this.loadShipments();
            } else {
                this.showNotify("Hata: " + (response?.error?.message || response?.error || "İşlem başarısız."), "error");
            }
        } catch (err) {
            console.error(err);
            this.showNotify("Bir hata oluştu.", "error");
        } finally {
            this.setState({ loading: false });
        }
    };

    // 🔥 DÜZELTME: Butona basınca Modal açmak yerine, DİREKT işlemi başlatıyoruz.
    handleCompleteDeliveryClick = (orderShipmentId: number) => {
        // ID'yi state'e atıyoruz ve callback olarak fonksiyonu çağırıyoruz
        this.setState({ shipmentToCompleteId: orderShipmentId }, () => {
             this.confirmDeliveryCompletion(false);
        });
    }

    // 🔥 ONAY VE HATA YÖNETİMİ
    confirmDeliveryCompletion = async (forceConfirm: boolean = false) => {
        const orderShipmentId = this.state.shipmentToCompleteId;
        if (!orderShipmentId) return;

        this.setState({ loading: true });

        try {
            const response = await ShipmentApi.finishLoading(orderShipmentId, forceConfirm);

            const errorData = response.error; // API'nin döndüğü hata objesi

            // Eksik yükleme kontrolü
            const hasMissingItems = errorData &&
                                    (errorData.type === "CONFIRMATION_REQUIRED" ||
                                    (Array.isArray(errorData.missingItems) && errorData.missingItems.length > 0));

            if (hasMissingItems) {
                const message = errorData.message || "Eksik yüklemeler var.";
                const missingItems = errorData.missingItems || [];

                let listStr = "";
                if (Array.isArray(missingItems)) {
                    listStr = missingItems.join("\n");
                } else {
                    listStr = String(missingItems);
                }

                const confirmText = `⚠️ UYARI: ${message}\n\nEKSİK OLAN ÜRÜNLER:\n------------------\n${listStr}\n\n------------------\nBu eksiklere rağmen işlemi onaylamak istiyor musunuz?`;

                // Tarayıcı Onay Kutusu (Tamam = Yine de Tamamla)
                if (window.confirm(confirmText)) {
                    await this.confirmDeliveryCompletion(true); // Recursive: True ile tekrar çağır
                    return;
                } else {
                    this.showNotify("İşlem iptal edildi.", "warning");
                    return;
                }
            }

            // NORMAL AKIŞ (Başarılı)
            if (response.success) {
                this.showNotify("Yükleme tamamlandı, irsaliye taslakları oluşturuldu! 📄🚛", "success");
                this.setState({ shipmentToCompleteId: null });
                await this.loadShipments();
            } else {
                // Sadece GERÇEK HATALAR
                const res = response as any;
                const msg = res.message || res.error?.message || (typeof res.error === 'string' ? res.error : "İşlem başarısız");
                this.showNotify("Hata: " + msg, "error");
            }

        } catch (err: any) {
            console.log("🔥 Catch Hatası:", err);
            const responseData = err.response?.data;
            const errorObj = responseData?.error;

            const isConfirmRequired = (err.response?.status === 409) || (errorObj && errorObj.type === "CONFIRMATION_REQUIRED");

            if (isConfirmRequired && errorObj) {
                 const message = errorObj.message || "Eksik yüklemeler var.";
                 const missingItems = errorObj.missingItems || [];
                 const listStr = Array.isArray(missingItems) ? missingItems.join("\n") : String(missingItems);

                 const confirmText = `⚠️ UYARI: ${message}\n\nEKSİK OLAN ÜRÜNLER:\n------------------\n${listStr}\n------------------\n\nBu eksiklere rağmen işlemi onaylamak istiyor musunuz?`;

                 if (window.confirm(confirmText)) {
                     await this.confirmDeliveryCompletion(true);
                     return;
                 } else {
                     this.showNotify("İşlem iptal edildi.", "warning");
                 }
            } else {
                let errorMsg = responseData?.message || err.message || "Bir hata oluştu";
                if(errorObj && errorObj.message) errorMsg = errorObj.message;
                this.showNotify("Hata: " + errorMsg, "error");
            }
        } finally {
            if (!forceConfirm) {
                this.setState({ loading: false });
            }
        }
    };

    // ==========================================
    // 3. YÜKLEME MODALI FONKSİYONLARI
    // ==========================================

    handleSearchProducts = (filteredItems: any[] | null) => {
        if (filteredItems === null) {
            this.setState({ filteredProducts: this.state.products });
        } else {
            this.setState({ filteredProducts: filteredItems });
        }
    }

    handleBoxClick = (point: FormationPoint, idx: number) => {
        this.setState({
            selectedBoxIndex: point.palletIdx ?? idx,
            selectedProduct: null,
            selectedWarehouse: null,
            quantity: '',
            selectedBuyer: null
        });
    }

    handleLoadItem = async () => {
            const {
                selectedShipmentId,
                selectedProduct,
                selectedBoxIndex,
                quantity,
                selectedWarehouse,
                loadingMode,
                selectedBuyer
            } = this.state;

            if (!selectedShipmentId || !selectedProduct || selectedBoxIndex === null) return alert("Eksik bilgi");
            if (!selectedWarehouse) return alert("Lütfen bir depo seçin");

            if (loadingMode === 'FREE' && !selectedBuyer) {
                return alert("Lütfen 'Serbest Yükleme' için bir Müşteri (Cari) seçiniz!");
            }

            const qtyNum = Number(quantity);
            if (!qtyNum || qtyNum <= 0) return alert("Geçerli bir adet girin");

            this.setState({ loading: true });

            try {
                const finalProductId = loadingMode === 'PLAN'
                                        ? selectedProduct.realProductId
                                        : selectedProduct.id;

                const dto = {
                    orderShipmentId: selectedShipmentId,
                    productId: finalProductId,
                    quantity: qtyNum,
                    palletIndex: selectedBoxIndex,
                    warehouseId: selectedWarehouse.id,
                    orderId: loadingMode === 'PLAN' ? selectedProduct.orderId : -1,
                    orderItemId: loadingMode === 'PLAN' ? selectedProduct.orderItemId : -1,
                    buyerId: loadingMode === 'FREE' && selectedBuyer ? selectedBuyer.id : null
                };

                const response = await ShipmentApi.loadOrderItemToShipment(dto);

                if (response.success) {
                    this.setState({ selectedProduct: null, quantity: '' });
                    if (this.state.selectedShipmentId) {
                        await this.fetchLoadedItems(this.state.selectedShipmentId);
                        await this.fetchPlannedItems(this.state.selectedShipmentId);
                    }
                    this.showNotify("Ürün başarıyla eklendi", "success");
                } else {
                    alert("Yükleme hatası: " + (response.error || "Bilinmeyen hata"));
                }
            } catch (err) {
                console.error(err);
                alert("Yükleme sırasında hata oluştu.");
            } finally {
                this.setState({ loading: false });
            }
        };

    handleDeleteLoadedItem = async (item: any) => {
            const { selectedShipmentId, selectedBoxIndex } = this.state;
            if (!selectedShipmentId || selectedBoxIndex === null) return;

            try {
                const dto = {
                    orderShipmentId: selectedShipmentId,
                    productId: item.productId,
                    palletIndex: selectedBoxIndex,
                    warehouseName: item.warehouseName,
                    orderId: item.orderId,
                    // ✅ EKLENEN KISIM: Backend'deki 'buyer_id' eşleşmesi için
                    buyerId: item.buyerId,
                    // Opsiyonel: Eğer elinde varsa warehouseId'yi de göndermek isim hatalarını önler
                    warehouseId: item.warehouseId
                };

                const response = await ShipmentApi.deleteLoadedPalletItem(dto);
                if (response.success) {
                    // Silme başarılıysa listeyi güncelle
                    this.fetchLoadedItems(selectedShipmentId);
                    // Planlananlar listesini de güncelle ki stok geri dönsün
                    this.fetchPlannedItems(selectedShipmentId);
                    this.showNotify("Ürün paletten kaldırıldı.", "warning");
                } else {
                    alert("Silme hatası: " + (response.error || "Bilinmeyen hata"));
                }
            } catch (err) {
                console.error(err);
                alert("Ürün silinirken hata oluştu.");
            }
    };

    getProductsToShow = () => {
            if (this.state.loadingMode === 'FREE') {
                return this.state.filteredProducts.length > 0
                    ? this.state.filteredProducts
                    : this.state.products;
            }
            if (!this.state.plannedItems || this.state.plannedItems.length === 0) {
                return [];
            }
            let mappedPlan = this.state.plannedItems.map(planItem => {
                const warehouseName = planItem.targetWarehouse || "Depo Belirtilmemiş";
                const textLabel = `${planItem.productName} - ${planItem.buyerName} - 📍 ${warehouseName}   👉 PLAN: ${planItem.plannedQuantity}`;
                return {
                    id: planItem.planningId || planItem.orderItemId,
                    realProductId: planItem.productId,
                    description: textLabel,
                    barcode: planItem.barcode,
                    orderId: planItem.orderId,
                    orderItemId: planItem.orderItemId,
                    plannedQuantity: planItem.plannedQuantity,
                    productName: planItem.productName,
                    buyerName: planItem.buyerName,
                    isPlanItem: true,
                    targetWarehouse: warehouseName,
                    orderCode: planItem.orderCode
                };
            });
            return mappedPlan;
        }

    render() {
        return (
            <AuthorizedPage role={Role.WAREHOUSE_STAFF}>
                <UniversalNotificationToast
                    show={this.state.notifyShow}
                    text={this.state.notifyMessage || ""}
                    type={(this.state.notifyType || "info") as any}
                    onClose={() => this.setState({ notifyShow: false })}
                />

                <div className="centered-95-percent">
                    <h2 className="mb-4">Sevkiyat Yükleme Paneli</h2>

                    <ShipmentList
                        shipments={this.state.shipments}
                        onInspect={this.handleViewLoadedItems}
                        onEdit={this.handleEditClick}
                        onComplete={this.handleCompleteDeliveryClick}
                        onUnconfirm={this.handleUnconfirmClick}
                    />

                    <ShipmentFormationModal
                        show={this.state.showFormationAndProductModal}
                        onHide={() => this.setState({ showFormationAndProductModal: false, selectedLayer: 1 })}
                        formationPoints={this.state.formationPoints}
                        selectedBoxIndex={this.state.selectedBoxIndex}
                        selectedLayer={this.state.selectedLayer}
                        loadedItems={this.state.loadedItems}
                        onBoxClick={this.handleBoxClick}
                        onLayerChange={(l) => this.setState({ selectedLayer: l })}
                        loadingMode={this.state.loadingMode}
                        setLoadingMode={(m) => this.setState({ loadingMode: m })}
                        products={this.getProductsToShow()}
                        onSearchProducts={this.handleSearchProducts}
                        selectedProduct={this.state.selectedProduct}
                        onSelectProduct={(p) => this.setState({ selectedProduct: p })}
                        plannedItems={this.state.plannedItems}
                        warehouses={this.state.warehouses}
                        selectedWarehouse={this.state.selectedWarehouse}
                        onSelectWarehouse={(w) => this.setState({ selectedWarehouse: w })}
                        buyers={this.state.buyers}
                        selectedBuyer={this.state.selectedBuyer}
                        onSelectBuyer={(b: any) => this.setState({ selectedBuyer: b })}
                        quantity={this.state.quantity}
                        onQuantityChange={(v) => this.setState({ quantity: v })}
                        onLoadItem={this.handleLoadItem}
                        onDeleteItem={this.handleDeleteLoadedItem}
                    />

                    <LoadedItemsModal
                        show={this.state.showLoadedItemsModal}
                        onHide={() => this.setState({ showLoadedItemsModal: false })}
                        loadedItems={this.state.loadedItems}
                        plannedItems={this.state.plannedItems}
                    />

                    {/* ❌ ConfirmationModal BURADAN KALDIRILDI */}
                </div>
            </AuthorizedPage>
        );
    }
}

export default WareHouseShipmentManagement;